import { z } from 'zod';
export const createAccountSchema = z.object({
    account_number: z.string().min(1, 'Account number is required').regex(/^\d+$/, 'Account number must be numeric'),
    title: z.string().min(1, 'Account title is required'),
    is_ira: z.boolean().optional().default(false),
    ira_custodian: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
});
export const updateAccountSchema = createAccountSchema.partial().extend({
    is_active: z.boolean().optional(),
});
//# sourceMappingURL=account.js.map